import { c as _c } from "react/compiler-runtime";
/**
 * Selo "Novo" das abas de entrada (`TabsButtonBorder.Item`), com o DOM que a aba de relatórios de
 * `/negociacoes` já tinha. O `NovoBadge` do menu lateral é outro desenho (Badge `brand`): unificar
 * os dois mudaria um deles e depende da designer.
 */
export function NovoSelo() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="bg-brand-50 text-brand-600 rounded px-1.5 py-0.5 text-[10px] font-medium">Novo</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}